import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_2 = { class: "flex flex-wrap gap-2 pt-2" }
const _hoisted_3 = {
  key: 2,
  class: "text-14px font-semibold text-gray-lp-300"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Chips = _resolveComponent("Chips")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_Title, { label: "Konfigurasi retur" }),
    (_ctx.detailData.isReturnConfig)
      ? (_openBlock(), _createBlock(_component_DataWrapper, {
          key: 0,
          class: "w-1/2 py-2",
          label: "Batas konfirmasi retur",
          value: _ctx.detailData.returnConfigLimit + ' hari'
        }, null, 8, ["value"]))
      : _createCommentVNode("", true),
    (_ctx.detailData.isReturnConfig)
      ? (_openBlock(), _createBlock(_component_DataWrapper, {
          key: 1,
          class: "w-1/2 py-2",
          label: "Alasan retur perlu dikonfirmasi",
          value: _ctx.getReasonList(_ctx.detailData.returnConfigReasonIds)
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_2, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getReasonList(_ctx.detailData.returnConfigReasonIds), (reason, id) => {
                return (_openBlock(), _createBlock(_component_Chips, {
                  key: id,
                  label: reason
                }, null, 8, ["label"]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["value"]))
      : _createCommentVNode("", true),
    (!_ctx.detailData.isReturnConfig)
      ? (_openBlock(), _createBlock("div", _hoisted_3, " Tidak ada konfigurasi "))
      : _createCommentVNode("", true)
  ], 64))
}